import {
    apiRequest,
    masterWorkUnit,
    lemburExport
} from "../../../../../services/adapters/kepegawaian/lemburService"

class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }

    fetchExport = async (query) => {
        return await apiRequest("get", lemburExport, {
            params: query
        }, true)
    }
}

export default IndexRepository